import { utils, Contract } from 'ethers';

/* Autogenerated file. Do not edit manually. */
var _abi = [{
  type: "event",
  anonymous: false,
  name: "LogManagerMigrated",
  inputs: [{
    type: "address",
    name: "newManager",
    indexed: true
  }]
}, {
  type: "event",
  anonymous: false,
  name: "LogRegistryChanged",
  inputs: [{
    type: "address",
    name: "oldR",
    indexed: false
  }, {
    type: "address",
    name: "newR",
    indexed: false
  }]
}, {
  type: "event",
  anonymous: false,
  name: "LogTokenFactoryChanged",
  inputs: [{
    type: "address",
    name: "oldTF",
    indexed: false
  }, {
    type: "address",
    name: "newTF",
    indexed: false
  }]
}, {
  type: "event",
  anonymous: false,
  name: "OwnershipTransferred",
  inputs: [{
    type: "address",
    name: "previousOwner",
    indexed: true
  }, {
    type: "address",
    name: "newOwner",
    indexed: true
  }]
}, {
  type: "function",
  name: "RegistryInstance",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "address"
  }]
}, {
  type: "function",
  name: "TokenFactoryInstance",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "address"
  }]
}, {
  type: "function",
  name: "approveProposal",
  constant: false,
  payable: false,
  inputs: [{
    type: "bytes32",
    name: "_hashIndex"
  }],
  outputs: []
}, {
  type: "function",
  name: "initialize",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_registry"
  }, {
    type: "address",
    name: "_tokenFactory"
  }],
  outputs: []
}, {
  type: "function",
  name: "initialized",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "bool"
  }]
}, {
  type: "function",
  name: "migrateManager",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_newManager"
  }],
  outputs: []
}, {
  type: "function",
  name: "owner",
  constant: true,
  stateMutability: "view",
  payable: false,
  inputs: [],
  outputs: [{
    type: "address"
  }]
}, {
  type: "function",
  name: "parseAddr",
  constant: true,
  stateMutability: "pure",
  payable: false,
  inputs: [{
    type: "bytes",
    name: "data"
  }],
  outputs: [{
    type: "address",
    name: "parsed"
  }]
}, {
  type: "function",
  name: "renounceOwnership",
  constant: false,
  payable: false,
  inputs: [],
  outputs: []
}, {
  type: "function",
  name: "setPlatformWallet",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_newPlatformWallet"
  }],
  outputs: []
}, {
  type: "function",
  name: "setRegistry",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_newRegistry"
  }],
  outputs: []
}, {
  type: "function",
  name: "setTokenFactory",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_newTokenFactory"
  }],
  outputs: []
}, {
  type: "function",
  name: "setTokenVesting",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_newTokenVesting"
  }],
  outputs: []
}, {
  type: "function",
  name: "setVestingAddress",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_token"
  }, {
    type: "address",
    name: "_vestingBeneficiary"
  }],
  outputs: []
}, {
  type: "function",
  name: "setVestingReferral",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "_token"
  }, {
    type: "address",
    name: "_vestingReferral"
  }],
  outputs: []
}, {
  type: "function",
  name: "submitProposal",
  constant: false,
  payable: false,
  inputs: [{
    type: "string",
    name: "_name"
  }, {
    type: "string",
    name: "_symbol"
  }, {
    type: "uint8",
    name: "_decimals"
  }, {
    type: "uint256",
    name: "_totalSupply"
  }, {
    type: "uint8",
    name: "_initialPercentage"
  }, {
    type: "uint256",
    name: "_vestingPeriodInDays"
  }, {
    type: "address",
    name: "_vestingBeneficiary"
  }, {
    type: "uint8",
    name: "_initialPlatformPercentage"
  }],
  outputs: [{
    type: "bytes32",
    name: "hashIndex"
  }]
}, {
  type: "function",
  name: "submitReferral",
  constant: false,
  payable: false,
  inputs: [{
    type: "bytes32",
    name: "_hashIndex"
  }, {
    type: "address",
    name: "_referral"
  }, {
    type: "uint8",
    name: "_referralPercentage"
  }],
  outputs: []
}, {
  type: "function",
  name: "transferOwnership",
  constant: false,
  payable: false,
  inputs: [{
    type: "address",
    name: "newOwner"
  }],
  outputs: []
}];
var Manager__factory = /** @class */function () {
  function Manager__factory() {}
  Manager__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  Manager__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  Manager__factory.abi = _abi;
  return Manager__factory;
}();

export { Manager__factory };
